exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3L1Ey{background-color:#003164;background-image:url(/images/breadcrumb_bg.jpg);background-position:50%;background-repeat:no-repeat;background-size:cover;height:248px;position:relative;width:100%}._3L1Ey:after{background-color:rgba(0,47,102,.8);bottom:0;content:\"\";left:0;position:absolute;right:0;top:0}._268rZ{color:#fff;margin:0 auto;max-width:1000px;padding:90px 0;position:relative;text-align:left;z-index:1}@media (max-width:768px){._268rZ{text-align:center}}._33goB{color:#fff;font-family:Roboto;font-size:24px;font-size:1.5rem;font-weight:300;letter-spacing:1px;margin:0}ul._2ftGd{list-style-type:none;margin:0;padding:8px 0}ul._2ftGd li{display:inline-block;font-size:15px;font-size:.9375rem;font-weight:300}ul._2ftGd a{color:#fff;text-decoration:none;-webkit-transition:.5s;-o-transition:.5s;transition:.5s}ul._2ftGd a:after{font-family:FontAwesome;content:\"\\F101\";margin:0 10px}ul._2ftGd a:hover{opacity:.8}", ""]);

// exports
exports.locals = {
	"root": "_3L1Ey",
	"container": "_268rZ",
	"entryTitle": "_33goB",
	"breadcrumb": "_2ftGd"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/components/Breadcrumb/Breadcrumb.css
// module id = 657
// module chunks = 0 1 2 3